module.exports = __webpack_public_path__ + "static/img/11.15bf5b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/11.png
// module id = xLoG
// module chunks = 0